
// export const defaultSettingsReceive = [
//   { name: 'stake', minStake: '0', maxStake: '' },
//   { name: 'sound' },
//   { name: 'music' },
//   { name: 'volume' },
// ]

export const defaultSettingsSend = [
  { name: 'stake', minStake: '0', maxStake: '' },
  { name: 'sound' },
  { name: 'music' },
  { name: 'volume' },
]
